
import RestfulProvider from "./http";
import http from "./http";

const signin = (params) => {
  return RestfulProvider.post("/api/user-admin-login", params);
};
const get_customer = (params) => {
  return RestfulProvider.post("/api/get-customer", params);
};

const punch = (params) => {
  return RestfulProvider.post("/api/create-punch", params);
};
const getTodayStatus = (params) => {
  return RestfulProvider.post("/api/get-today-status", params);
};

const getAdminDetails = (params) => {
  return RestfulProvider.post("/api/get-admin", params);
};

const getAttendanceByDateRange = (params) => {
  return RestfulProvider.post("/api/get-attendance-by-date-range", params);
};

const getleaveTypes = (params) => {
  return RestfulProvider.get("/api/get-leave-types", params);
};

const getActiveGlobalHolidays = (data) => {
  return RestfulProvider.get(`/api/get-active-holiday/${data}`);
};
const createLeave = (data) => {
  return RestfulProvider.post(`/api/create-leave`, data);
};
const getLeaves = (data) => {
  return RestfulProvider.post(`/api/get-leave-auth`, data);
};

const getJobs = (data) => {
  return RestfulProvider.post(`/api/my-jobs`, data);
};

const getMyJobs = (data) => {
  return RestfulProvider.post(`/api/my-jobs`, data);
};

const changeStatus = (id, data) => {
  const isFormData = data instanceof FormData;
  return RestfulProvider.post(`/api/jobs/${id}/change-status`, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
  });
};

const attendanceregularization = (data) => {
  return RestfulProvider.post(`/api/attendanceregularization`, data); // Fixed URL
};

const getAttendanceRegularizationById = (id) => {
  return RestfulProvider.get(`/api/attendance-regularization/{id}'`);
};

const approveAttendanceRegularization = (id, data) => {
  return RestfulProvider.post(`/api/approve-attendance-regularization/${id}`, data);
};

const denyAttendanceRegularization = (id, data) => {
  return RestfulProvider.post(`/api/deny-attendance-regularization/${id}`, data);
};

const getRegularizationList = (params) => {
  return RestfulProvider.post('/api/get-regularization-list', params);
};

const getSiteAttendanceByDate = (params) => {
  return RestfulProvider.post('/api/get-site-attendance-by-date', params);
};

const getAttendanceById = ({ id }) => {
  return RestfulProvider.get(`/api/attendance/${id}`);
};

const saveEmployeeAccountDetails = (data) => {
  return RestfulProvider.post(`/api/save-employee-account-details`, data);
};

const getEmployeeAccountDetails = (data) => {
  return RestfulProvider.post(`/api/get-employee-account-details`, data);
};

const getCustomerLedger = (params) => {
  return RestfulProvider.post('/api/get-customer-ledger', params); // apna actual route URL daal do
};

const getSalarySlip = (params) => {
  return RestfulProvider.post('/api/get-salary-slip', params);
};

const downloadSalarySlip = (params) => {
  return RestfulProvider.post('/api/download-salary-slip', params, { responseType: 'blob' });
};

const updateLeaveStatus = (id, data) => {
  return RestfulProvider.post(`/api/update-leave-status/${id}`, data);
}

const subordinateCustomerLeaveList = (params) => {
  return RestfulProvider.post('/api/subordinate-customer-ids', params);
};


const getSubordinateCustomerRegularizationList = (params) => {
  return RestfulProvider.post('/api/subordinate-customer-regularization-list', params);
};

const updateRegularizationStatus = (id, data) => {
  return RestfulProvider.post(`/api/regularization-status-update/${id}`, data);
};

const getMyRoster = (params) => {
  return RestfulProvider.get('/api/get-my-roster', params);
};

// Complaint related services

const complaintCategories = (params) => {
  return RestfulProvider.post(`/api/complaint-categories`, params);
};

const complaintRegister = (data) => {
  const isFormData = data instanceof FormData;
  return RestfulProvider.post(`/api/complaint-register`, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
  });
};

const complaintTrack = (params) => {
  return RestfulProvider.post(`/api/complaint-track`, params);
};

const complaintUserProfile = (params) => {
  return RestfulProvider.post(`/api/complaint-user-profile`, params);
};

// 🔹 NEW — Complaint assignment services

const complaintMyComplaints = (params) => {
  return RestfulProvider.post(`/api/complaint-my-complaints`, params);
};

const complaintPendingByCategory = (params) => {
  return RestfulProvider.post(`/api/complaint-pending-by-category`, params);
};

const complaintStartWork = (params) => {
  return RestfulProvider.post(`/api/complaint-start-work`, params);
};

const getAssignedSites = (params) => {
  return RestfulProvider.post("/api/employee/assigned-sites", params);
};


const getMyLeaveBalance = (params) => {
  return RestfulProvider.get(`/api/leave-balance/my`, params);
};



const configService = {
  signin,
  getLeaves,
  createLeave,
  get_customer,
  punch,
  getTodayStatus,
  getAdminDetails,
  getAttendanceByDateRange,
  getleaveTypes,
  getActiveGlobalHolidays,
  getJobs,
  getMyJobs,
  changeStatus,
  attendanceregularization,
  getAttendanceRegularizationById,
  approveAttendanceRegularization,
  denyAttendanceRegularization,
  getRegularizationList,
  getSiteAttendanceByDate,
  getAttendanceById,
  getEmployeeAccountDetails,
  saveEmployeeAccountDetails,
  getCustomerLedger,
  getSalarySlip,
  downloadSalarySlip,
  updateLeaveStatus,
  subordinateCustomerLeaveList,
  getSubordinateCustomerRegularizationList,
  updateRegularizationStatus,
  getMyRoster,
  complaintCategories,
  complaintRegister,
  complaintTrack,
  complaintUserProfile,
  complaintMyComplaints,
  complaintPendingByCategory,
  complaintStartWork,
  getAssignedSites,
  getMyLeaveBalance,


};

export default configService;

